import axios from 'axios'
import router from '@/router';
import qs from 'qs';
import { get_local_desc, get_local_device_p7b, slm_ctrl_sign_by_device } from '@/api/shield'
import { getHash } from '@/api/user'

class HttpRequest {
    constructor(baseUrl = baseURL) {
        this.baseUrl = baseUrl
        this.queue = {}
    }
    getInsideConfig() {
        const config = {
            baseURL: this.baseUrl,
            headers: {
                //
            }
        }
        return config
    }
    destroy(url) {
        delete this.queue[url]
        if (!Object.keys(this.queue).length) {
            // Spin.hide()
        }
    }
    interceptors(instance, url) {
        let interceptor_urls = [
            "/api/admin/user/checkShield",
            "/api/admin/producer/save",
            "/api/admin/producer/del",
            "/api/admin/devicework/save",
            "/api/admin/devicework/del",
            "/api/admin/devicecheck/save",
            "/api/admin/devicecheck/del",
            "/api/admin/devicecheck/saveRelationDevice",
            "/api/admin/devicecheck/borrow",
            "/api/admin/deviceextract/save",
            "/api/admin/deviceextract/del",
            "/api/admin/deviceextract/saveRelationDevice",
            "/api/admin/deviceextract/borrow",
            "/api/admin/alertcancellog/save",
            "/api/admin/flowmeter/save",
            "/api/admin/flowmeter/del",
            "/api/admin/flowmeter/borrow",
            "/api/admin/tablets/save",
            "/api/admin/tablets/del",
            "/api/admin/tablets/borrow",
            "/api/admin/routers/save",
            "/api/admin/routers/del",
            "/api/admin/routers/borrow",
            "/api/admin/netcard/save",
            "/api/admin/netcard/del",
            "/api/admin/netcard/borrow",
            "/api/admin/devicetestlog/save",
            "/api/admin/devicetestlog/del",
            "/api/admin/devicerelationtimelog/save",
            "/api/admin/devicerelationtimelog/del",
        ]
        // 请求拦截
        instance.interceptors.request.use(async config => {
            this.queue[url] = true;
            let data = config.data;

            let params = {};
            for (var key in config.data) {
                params[key] = data[key];
            }
            config.data = qs.stringify(params, { arrayFormat: 'brackets' });
            if (process.env.NODE_ENV != 'development' && interceptor_urls.indexOf(config.url)>=0) {
                let shield_res = await test()
                if(shield_res == '2'){
                    return Promise.reject(new Error("未发现加密锁"))
                }else if(shield_res == '3'){
                    return Promise.reject(new Error("发现多把加密锁，请拔出其中一把后重试"))
                }else if(shield_res == '3'){
                    return Promise.reject(new Error("发现多把加密锁，请拔出其中一把后重试"))
                }else if(shield_res == '4'){
                    return Promise.reject(new Error("获取加密锁证书链出错"))
                }else if(shield_res == '5'){
                    return Promise.reject(new Error("使用加密锁签名出错"))
                }else if(shield_res == '9'){
                    return Promise.reject(new Error("请安装U盾相应服务"))
                }else{
                    let t = shield_res.split(":")
                    config.headers['shell-num'] = t[0]
                    config.headers['lock-sn'] = t[1]
                    config.headers['verify-data'] = t[2]
                }
            }
            return config
        }, error => {
            return Promise.reject(error)
        })
        // 响应拦截
        instance.interceptors.response.use(res => {
            this.destroy(url)
            const {
                data,
                status
            } = res
            if (res.data.code === 998) {
                //无权限
                router.push({
                    path: '/jurisdiction'
                });
            } else if (res.data.code === 999) {
                sessionStorage.removeItem("U_TOKEN")
                let redirectPath = router.currentRoute.fullPath
                sessionStorage.setItem("redirectPath", redirectPath)
                //未登录
                setTimeout(() => {
                    router.push({
                        path: '/admin/login'
                    });
                }, 300);
            } else if (res.data.code === 997) {
                alert("加密锁验证失败")
            } else if (res.data.code === 888) {
                //无权限
                router.push({
                    path: '/dealer/Fjurisdiction'
                });
            } else if (res.data.code === 889) {
                //未登录
                sessionStorage.removeItem("U_TOKEN")
                localStorage.removeItem("fActMenu")
                let MOBILE_LOGIN = localStorage.getItem("MOBILE_LOGIN");
                if (MOBILE_LOGIN != null && MOBILE_LOGIN != undefined && MOBILE_LOGIN == "1") {
                    setTimeout(() => {
                        router.push({
                            path: '/m/login'
                        });
                    }, 300);
                } else {
                    setTimeout(() => {
                        router.push({
                            path: '/login'
                        });
                    }, 300);
                }
            }
            return data
        }, error => {
            this.destroy(url)
            if(hasZh(error.message)){
                alert(error.message)
            }
            return Promise.reject(error)
        })
    }
    request(options) {
        const instance = axios.create()
        options = Object.assign(this.getInsideConfig(), options)
        this.interceptors(instance, options.url)
        return instance(options)
    }
}

function test(){
    return new Promise((resolve) => {
        get_local_desc().then(res=>{
            if(res.code == 0){
                let local_desc = JSON.parse(res.data);
                if (local_desc.length === 0) {
                    //alert("未发现加密锁")
                    resolve("2");
                    return Promise.reject(new Error("aaa"))
                }else if (local_desc.length !== 1) {
                    //this.$msg("发现多把加密锁，请拔出其中一把后重试")
                    resolve("3");
                    return
                }
                get_local_device_p7b().then(res1=>{
                    if(res1.code ==0){
                        let detail = JSON.parse(res1.data)[0];
                        let shell_num = detail["shell_num"];
                        let lock_sn = detail["lock_sn"];
                        let local_desc_str = JSON.stringify(local_desc[0]);
                        getHash().then(res2=>{
                            if(res2.code == 1){
                                let random_value = res2.data
                                let signdata = window.btoa("SENSELOCK" + random_value);
                                slm_ctrl_sign_by_device(local_desc_str, signdata).then(res3=>{
                                    if(res3.code == 0){
                                        resolve(shell_num+":"+lock_sn+":"+res3.data);
                                    }else{
                                        resolve("5");
                                    }
                                })
                            }else{
                                resolve("4");
                            }
                        })
                    }else{
                        resolve("4");
                        //this.$msg("获取加密锁证书链出错：" + res1.code)
                    }
                })
            }
        }).catch(error=>{
            //alert("请安装U盾相应服务")
            resolve("9");
        })
    })
}

function hasZh(str) {
    var zh_check = /[\u4e00-\u9fa5]/;
    return zh_check.test(str);
}

export default HttpRequest
